import { API } from "../index"

export const DNS_ENDPOINTS = {
  getCP(params={}){
    return API.Axios.central_point.v2.request({
      url: `centeral-point`,
      method: "GET",
      params,
    })
  },
  getCPList(params={}){
    return API.Axios.central_point.v2.request({
      url: `centeral-point/all`,
      method: "GET",
      params,
    })
  },
  checkMaintenance(params={}){
    return API.Axios.central_point.v2.request({
      url: `centeral-point/check-maintenance`,
      method: "GET",
      params,
    })
  },
  deviceInfo(){
    return API.Axios.relay_proxy.v1.request({
      url: `device-info`,
      method: "GET",
      extra_data: {
        device_info: true,
      },
    })
  },
  verifyPincode(data={}){
    return API.Axios.central_point.v1.request({
      url: `verify-pincode`,
      method: "POST",
      data,
    })
  },
}